import $ from 'jquery';
import '../vendor/jquery.smartbanner';

export default function(localOptions) {
  var defaultOptions = {appendToSelector : '#home'};
  var globalOptions = window.rcProps && window.rcProps.smartBanner || {};
  localOptions = localOptions || {};
  return $.smartbanner($.extend(true, defaultOptions, globalOptions, localOptions));
};



// WEBPACK FOOTER //
// ./src/scripts/modules/smart-banner.js